/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_EquationInputs */

const en_reading_class_equation = /** @type {(inputs: Reading_Class_EquationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Math`)
};

const es_reading_class_equation = /** @type {(inputs: Reading_Class_EquationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matemáticas`)
};

/**
* | output |
* | --- |
* | "Math" |
*
* @param {Reading_Class_EquationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_equation = /** @type {((inputs?: Reading_Class_EquationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_EquationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_equation(inputs)
	return en_reading_class_equation(inputs)
});